// AUTO-GENERATED by scripts/generate-api-mappings.py — do not edit manually
import { ApiTarget } from '../environment/api-environment.model';

export interface ApiRoutePrefixRule {
  prefix: string;
  target: ApiTarget;
}

/** Longest-prefix-first order matters for correct matching. */
export const API_ROUTE_PREFIXES: ReadonlyArray<ApiRoutePrefixRule> = [
  { prefix: 'programpartnertypes', target: 'admin' },
  { prefix: 'entraUserAccess/', target: 'admin' },
  { prefix: 'student-rosters/', target: 'portal' },
  { prefix: 'taskAssignment/', target: 'admin' },
  { prefix: 'documenttypes', target: 'admin' },
  { prefix: 'senddocuments/', target: 'integration' },
  { prefix: 'globalSearch/', target: 'portal' },
  { prefix: 'agreements', target: 'admin' },
  { prefix: 'appversion', target: 'admin' },
  { prefix: 'commcenter', target: 'integration' },
  { prefix: 'enrollment', target: 'portal' },
  { prefix: 'household', target: 'portal' },
  { prefix: 'schedules', target: 'admin' },
  { prefix: 'tasktypes', target: 'admin' },
  { prefix: 'valueList/', target: 'admin' },
  { prefix: 'workflows', target: 'infrastructure' },
  { prefix: 'admcomms', target: 'integration' },
  { prefix: 'metabase', target: 'infrastructure' },
  { prefix: 'PandaDoc', target: 'integration' },
  { prefix: 'pandadoc', target: 'integration' },
  { prefix: 'partners', target: 'portal' },
  { prefix: 'personas', target: 'portal' },
  { prefix: 'students', target: 'admin' },
  { prefix: 'history', target: 'admin' },
  { prefix: 'refunds', target: 'admin' },
  { prefix: 'schools', target: 'portal' },
  { prefix: 'institution', target: 'portal' },
  { prefix: 'signalr/', target: 'infrastructure' },
  { prefix: 'student/', target: 'portal' },
  { prefix: 'awards', target: 'admin' },
  { prefix: 'comms', target: 'integration' },
  { prefix: 'Files/', target: 'infrastructure' },
  { prefix: 'tasks', target: 'admin' },
  { prefix: 'dnpe', target: 'infrastructure' },
  { prefix: 'task/', target: 'admin' },
  { prefix: 'nsc', target: 'admin' },
  { prefix: 'account', target: 'portal' }
];
